export const animationConfig = { mass: 1, tension: 400, friction: 20, clamp: true }
